
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { FinancialAssumptions } from './types';

interface GeneralTabProps {
  assumptions: FinancialAssumptions;
  onInputChange: (section: keyof FinancialAssumptions, field: string, value: string | number) => void;
}

export function GeneralTab({ assumptions, onInputChange }: GeneralTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="forecastPeriod">Forecast Period (years)</Label>
          <Input
            id="forecastPeriod"
            type="number"
            value={assumptions.general.forecastPeriod}
            onChange={(e) => onInputChange('general', 'forecastPeriod', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="discountRate">Discount Rate (%)</Label>
          <Input
            id="discountRate"
            type="number"
            value={assumptions.general.discountRate}
            onChange={(e) => onInputChange('general', 'discountRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="baseYear">Base Year</Label>
          <Input
            id="baseYear"
            type="number"
            value={assumptions.general.baseYear}
            onChange={(e) => onInputChange('general', 'baseYear', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="currency">Currency</Label>
          <Input
            id="currency"
            value={assumptions.general.currency}
            onChange={(e) => onInputChange('general', 'currency', e.target.value)}
          />
        </div>
        <div className="md:col-span-2">
          <Label htmlFor="notes">Notes</Label>
          <Textarea
            id="notes"
            placeholder="Additional assumptions and notes..."
            value={assumptions.general.notes}
            onChange={(e) => onInputChange('general', 'notes', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
